import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ConnectedRouter } from 'react-router-redux';
import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import history from '../../history';
import { store, persistor } from '../../store';
import './App.css';
import data from '../../components/data';
import QuestionnairePage from '../../components/QuestionnairePage/QuestionnairePage';
import PatientHome from '../../components/PatientHome/PatientHome';
import Login from '../Login/Login';
import PatientList from '../../components/PatientContainer';
import PatientEdit from '../../components/PatientDetails/PatientEdit';
import RecommendationsPage from '../../components/RecommendationsPage/RecommendationsPage';
import UserDetails from '../../components/UserDetails/UserDetails';
import RecipientDetails from '../../components/RecipientDetails/RecipientDetails';
import LoginParse from '../Login/LoginParse';

const App = () => (
  // when store changes, app is re-rendered
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ConnectedRouter history={history}>
        <div className="App">
          <Switch>
            <Route path="/" exact component={Login} />
            <Route path="/questionnairePage/">
              <QuestionnairePage data={data} history={history} />
            </Route>
            <Route path="/PatientList" component={PatientList} />
            <Route path="/PatientEdit" component={PatientEdit} />
            <Route path="/PatientHome" exact component={PatientHome} />
            <Route path="/UserDetails" exact component={UserDetails} />
            <Route path="/RecipientDetails" exact component={RecipientDetails} />
            <Route
              path="/Recommendations"
              exact
              component={RecommendationsPage}
            />
            {/* <Route path="/newRecommendations/">
              <QuestionnairePage data={data} history={history} />
            </Route> */}
            <Route path="/LoginParse" component={LoginParse} />
          </Switch>
        </div>
      </ConnectedRouter>
    </PersistGate>
  </Provider>
);

export default App;


// WEBPACK FOOTER //
// ./src/containers/App/App.js